import styled, { css } from 'styled-components';

const Column = styled.div`
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: 100px;
  ${(props) =>
    !!props.width &&
    css`
      flex-basis: ${props.width};
      max-width: ${props.width};
    `}
  ${(props) =>
    !!props.centerContent &&
    css`
      justify-content: center;
    `}
`;
export default Column;
